import React from "react"
import PropTypes from "prop-types"

import styled from "styled-components"
import Card from "components/atoms/Card"
import Box from "components/atoms/Box"
import Flex from "components/atoms/Flex"
import { Text, Paragraph } from "components/atoms/Typography"

const WrappedCard = styled(Card)`
  transition: all 0.4s ease;
  transition-property: box-shadow opacity;
  a {
    color: inherit;
    opacity: 1;
    transition: opacity 0.1s ease;
    &:hover {
      opacity: 0.7;
    }
  }
  &.shadow:hover {
    box-shadow: 0px 6px 35px #c5c9d9;
  }
`

const TweetCard = ({
  bg,
  color,
  boxShadow,
  time,
  content,
  screenName,
  link,
}) => {
  return (
    <WrappedCard
      className={boxShadow && boxShadow !== "none" ? "shadow" : ""}
      bg={bg ? bg : undefined}
      color={color}
      borderRadius={0}
      boxShadow={boxShadow ? boxShadow : undefined}
      px={4}
      py={6}
      marginX="auto"
      maxWidth={30}
      height="100%"
    >
      <Flex height="100%" flexDirection="column" justifyContent="space-between">
        <div>
          <Paragraph fontSize="18px" color="inherit">
            @{screenName}
          </Paragraph>
          <Paragraph fontSize="14px" color="inherit" mb={5}>
            {time}
          </Paragraph>
          <Paragraph
            fontSize="14px"
            fontWeight="light"
            color="inherit"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </div>
        <div>
          <Box mt="38px">
            <a
              style={{ textDecoration: "none" }}
              href={link}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Text color="inherit" fontSize={1}>
                View Tweet
              </Text>
            </a>
          </Box>
        </div>
      </Flex>
    </WrappedCard>
  )
}

TweetCard.propTypes = {
  bg: PropTypes.number,
  boxShadow: PropTypes.string,
  time: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
}

export default TweetCard
